<script setup lang="ts">
const pageTitle = usePageTitle()

// theme-color = фон страницы в текущей теме (панель браузера на телефоне в цвет приложения)
const colorMode = useColorMode()
const themeColor = computed(() => (colorMode.value === 'dark' ? '#1e2939' : '#F4F7FB'))

useHead({
  titleTemplate: (title) => (title ? `${title} — Zakupki HUB` : 'Zakupki HUB'),
  title: pageTitle,
  meta: [{ name: 'theme-color', content: themeColor }],
  // Общая тема всех приложений: цвета задаются в «Дизайне» админки сайта
  // (192.168.1.88:5176/app/site/design), nginx проксирует /theme.css с сайта.
  // Перекрывает запасные значения шкалы primary из assets/css/main.css.
  link: [{ rel: 'stylesheet', href: '/theme.css' }],
})

// Уведомление о cookie (как на сайте и в /app nuxt-ui-templates). Здесь только
// cookie входа auth_token — без неё приложение не работает, поэтому «Отказаться»
// лишь запоминает выбор.
const cookieConsent = useCookie<'accepted' | 'declined' | null>('cookie_consent', {
  maxAge: 60 * 60 * 24 * 365,
  sameSite: 'lax',
  path: '/',
})
const toast = useToast()
const siteUrl = useRuntimeConfig().public.siteUrl

onMounted(() => {
  if (cookieConsent.value === 'accepted' || cookieConsent.value === 'declined') return
  toast.add({
    id: 'cookie-consent',
    title: 'Мы используем cookie',
    description: 'Они нужны для входа и работы приложения.',
    icon: 'i-lucide-cookie',
    duration: 0,
    close: false,
    actions: [{
      label: 'Принять',
      color: 'primary',
      onClick: () => { cookieConsent.value = 'accepted' },
    }, {
      label: 'Отказаться',
      color: 'neutral',
      variant: 'outline',
      onClick: () => { cookieConsent.value = 'declined' },
    }, {
      label: 'Подробнее',
      color: 'neutral',
      variant: 'link',
      to: `${siteUrl}/privacy`,
      target: '_blank',
    }],
  })
})
</script>

<template>
  <UApp :toaster="{ position: 'bottom-right' }">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <ChatFab />
  </UApp>
</template>
